module.exports = __webpack_public_path__ + "images/dingtalk_qrcode_bj-ee2fefa7396158b02b4eb6b51ab046a6.png";